import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _c(
        VForm,
        {
          ref: "form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(VSelect, {
            attrs: {
              items: _vm.availableProducts,
              "item-text": "name",
              "item-value": "id",
              label: _vm.$vuetify.lang.t("$vuetify.worksheet.selectProduct"),
              loading: _vm.loading,
              disabled: _vm.loading || _vm.submitted,
              rules: [
                (v) =>
                  !!v || _vm.$vuetify.lang.t("$vuetify.validation.required"),
              ],
            },
            on: { change: _vm.onProductChange },
            model: {
              value: _vm.selectedProduct,
              callback: function ($$v) {
                _vm.selectedProduct = $$v
              },
              expression: "selectedProduct",
            },
          }),
          _c(
            VBtn,
            {
              staticClass: "mt-4",
              attrs: {
                disabled: !_vm.valid || _vm.loading || _vm.submitted,
                color: "primary",
              },
              on: { click: _vm.submit },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$vuetify.lang.t("$vuetify.base.update")) + " "
              ),
            ]
          ),
        ],
        1
      ),
      _vm.loading
        ? _c(VProgressCircular, {
            staticClass: "ma-4",
            attrs: { indeterminate: "", color: "primary" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }